import apiClient from './client'

export interface Tag {
  id: string
  name: string
}

export interface TagCreate {
  name: string
}

export interface TagUpdate {
  id: string
  name: string
}

export interface TagsResponse {
  data: Tag[]
}

// Get all tags for current user
export async function getTags(): Promise<Tag[]> {
  const response = await apiClient.get<TagsResponse>('/tags/')
  return response.data.data
}

// Create a new tag
export async function createTag(tag: TagCreate): Promise<Tag> {
  const response = await apiClient.post<Tag>('/tags/', tag)
  return response.data
}

// Update an existing tag
export async function updateTag(tag: TagUpdate): Promise<Tag> {
  const response = await apiClient.put<Tag>('/tags/', tag)
  return response.data
}

// Delete a tag
export async function deleteTag(tagId: string): Promise<void> {
  await apiClient.delete(`/tags/${tagId}`)
}
